import { render, staticRenderFns } from "./HangmanList.vue?vue&type=template&id=28c2e5de"
import script from "./HangmanList.vue?vue&type=script&lang=js"
export * from "./HangmanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports